import { useTranslation } from 'next-i18next';
import SupportFaqQuestions from 'components/Layout/Support/SupportFaqQuestions';
import SupportDiscord from 'components/Layout/Support/SupportDiscord';
import SupportEmail from 'components/Layout/Support/SupportEmail';
import StartMining from 'components/Layout/Mining/StartMining';
import { Faq, Group } from 'types/FaqQuestions';
import { ClockIcon } from 'images/svg';
import SectionTitle from 'components/SectionTitle';

interface Props {
  data: Faq;
}

const MiningContent = (props: Props) => {
  const { data } = props;

  const { t } = useTranslation();

  const flatten = data => [...Object.values(data).flat()] as Group[];

  return (
    <>
      <div className="support">
        <SectionTitle header="support.pageHero.header" />
        <div className="support__faq">
          <SupportFaqQuestions
            groups={flatten(data?.groups || [])}
            questions={data?.questions || []}
          />
          <div className="support__faq-communication">
            <SupportDiscord
              header={t('support.supportDiscord.header')}
              description={t('support.supportDiscord.description')}
            >
              <div className="support-discord__footnotes">
                <ClockIcon />
                <span>{t('support.supportDiscord.footnotes')}</span>
              </div>
            </SupportDiscord>
            <SupportEmail email="admin@simplemining.net" />
          </div>
        </div>
      </div>
      <StartMining />
    </>
  );
};

export default MiningContent;
